import { render, staticRenderFns } from "./ControllerRecruiment.vue?vue&type=template&id=45627852&scoped=true&"
import script from "./ControllerRecruiment.vue?vue&type=script&lang=js&"
export * from "./ControllerRecruiment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45627852",
  null
  
)

export default component.exports